import React, { useEffect, useState } from "react";
import { ArrowRight, Sparkles, X } from "lucide-react";

const STORAGE_KEY = "epsilon_exit_shown";

const ExitIntent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    let armed = false;
    const armTimer = setTimeout(() => {
      armed = true;
    }, 4000);

    const onMouseOut = (e) => {
      if (!armed) return;
      if (e.clientY <= 0 && !e.relatedTarget) {
        setOpen(true);
        sessionStorage.setItem(STORAGE_KEY, "1");
        window.removeEventListener("mouseout", onMouseOut);
      }
    };

    const fallback = setTimeout(() => {
      if (sessionStorage.getItem(STORAGE_KEY)) return;
      setOpen(true);
      sessionStorage.setItem(STORAGE_KEY, "1");
    }, 45000);

    window.addEventListener("mouseout", onMouseOut);
    return () => {
      window.removeEventListener("mouseout", onMouseOut);
      clearTimeout(armTimer);
      clearTimeout(fallback);
    };
  }, []);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={() => setOpen(false)}
      />
      <div className="relative card-glow rounded-2xl p-8 md:p-10 max-w-[520px] w-full animate-in fade-in zoom-in duration-300">
        <button
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 text-slate-400 hover:text-white transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="inline-flex items-center gap-2 chip-blue px-4 py-2 rounded-full">
          <Sparkles className="w-3.5 h-3.5" />
          <span className="text-[11px] tracking-[0.32em] uppercase">
            Wait &mdash; One Moment
          </span>
        </div>

        <h3 className="font-display text-[38px] md:text-[42px] leading-[1.02] mt-6 text-gradient-title">
          Don't leave AI
        </h3>
        <p className="font-italic-serif text-[32px] text-gradient-blue leading-none">
          to chance.
        </p>

        <p className="text-slate-300/85 text-[15px] leading-relaxed mt-6">
          Most professionals who watch this webinar save 5+ hours in their first week applying it. Your seat is still free &mdash; it takes 60 seconds.
        </p>

        <a
          href="#register"
          onClick={() => setOpen(false)}
          className="mt-7 flex items-center justify-center gap-2 w-full py-4 rounded-full bg-[#5EC7F5] text-[#062026] font-semibold text-sm glow-blue-btn hover:bg-[#8ad8f7] transition-colors"
        >
          Reserve My Seat <ArrowRight className="w-4 h-4" />
        </a>

        <button
          onClick={() => setOpen(false)}
          className="mt-4 w-full text-center text-slate-400 hover:text-slate-200 text-[13px] py-3 rounded-full border hairline hover:border-[#5EC7F5]/30 transition-colors"
        >
          No thanks, I'll figure AI out on my own.
        </button>
      </div>
    </div>
  );
};

export default ExitIntent;
